import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row, VertButton, VertImage, VertTypography } from '@vertem-core/vertice-ds';

import { EVendorType } from 'enums/orders';
import { pointsMask } from 'Utils/commons/points';
import { useRating } from 'components/RatingProducts/Provider';
import useSupplier from 'Hooks/useSupplier';
import generateUUID from 'Utils/generateUUID';
import { limitString } from 'Utils/commons/string';
import { OrderStatus } from './OrderStatus';
import RatingProducts from 'components/RatingProducts';
import ynToBool from 'Utils/ynToBool';
import { currencyMask } from 'Utils/commons/mask';

export const OrderItemMobile = ({
  order,
  checkIfOrderWas10DaysAgo,
  handleChangeSkuTarget,
  skuTargetForRating,
  ratingModalOpen,
  handleOpenModalTracking,
  handleChangeModal,
}) => {
  const { vendorOrderModel, isVirtual } = order;

  const Catalog = useSelector(({ Catalog: data }) => data);
  const { isEnabled, filterProductsWithoutRating, ratingList, configRating, isLoading } = useRating();
  const { supplierWithoutShipping } = useSupplier(vendorOrderModel);

  const {
    currencyConfiguration: { decimalPlaces, pointsName },
  } = Catalog;

  return vendorOrderModel.map((vendor) => {
    const hasFreeShipping = vendor.totalShippingValue === 0 && 'highlight';
    const isPaymentWithPointsAndCash =
      vendor.vendorType === EVendorType.E_COMMERCE &&
      order.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal !== 0;
    const totalCashValue = isPaymentWithPointsAndCash
      ? order.orderPaymentDetailMoneyAndPoints.purchaseValueDecimal
      : 0;

    const formattedShipping = pointsMask(vendor.totalShippingValue, decimalPlaces, pointsName);

    const items =
      isEnabled && vendor.items && vendor.items.length
        ? filterProductsWithoutRating(
            vendor.items.map(({ imageUrl, name, productSkuId }) => ({
              productImg:
                imageUrl ||
                'https://vertice-ds.s3.amazonaws.com/Assets/Images/fallbacks/fallback-img-store.png',
              productName: name,
              seller: vendor.vendorName,
              orderId: vendor.orderId,
              supplierId: vendor.vendorId,
              productSku: productSkuId,
            })),
          )
        : [];

    return (
      <Col className='order-item-list col' key={generateUUID()}>
        <Col className='order-vendor-and-shipping col'>
          <VertTypography.Paragraph className='order-vendor'>
            Fornecido e entregue por <span>{vendor.vendorName}</span>
          </VertTypography.Paragraph>
          <VertTypography.Paragraph className={`order-shipping ${hasFreeShipping}`}
             style={{
              display: ynToBool(process.env.REACT_APP_HIDE_FREIGHT) ? 'none' : ''
            }}
          >
            Frete:{' '}
            <span>
              {hasFreeShipping ? 'Grátis' : `${formattedShipping.value} ${formattedShipping.label}`}
            </span>
          </VertTypography.Paragraph>
        </Col>

        {vendor.items.map((item) => {
          const formattedItemValue = pointsMask(item.sellingPrice, decimalPlaces, pointsName);
          const hasFreeItem = formattedItemValue.value == 0;

          return (
            <Col className='order-item' key={generateUUID()}>
              <Col className='item-info'>
                <VertImage rootClassName='item-image' alt={item.vendorName} src={item.imageUrl} />
                <Col className='col'>
                  <VertTypography.Paragraph className='item-name'>
                    {limitString(item.name)}
                  </VertTypography.Paragraph>
                  <OrderStatus status={vendor?.status} />
                  {isEnabled &&
                    ratingList[item?.productSkuId] &&
                    configRating.minimumRatingQuantity <= ratingList[item?.productSkuId].rating && (
                      <div className='padding-y-extra-small'>
                        <SmallRate rate={ratingList[item?.productSkuId].rating} total={5} />
                      </div>
                    )}

                  {!isVirtual && (
                    <Col className='item-track-shipping col'>
                      <VertTypography.Paragraph
                        onClick={() => handleOpenModalTracking(vendor, item)}
                      >
                        Rastrear
                      </VertTypography.Paragraph>
                    </Col>
                  )}

                  <Col className='item-value col'>
                    <VertTypography.Paragraph>
                      Total:{' '}
                      <span className={`${hasFreeItem ? 'color-highlight' : ''}`}>
                        {hasFreeItem
                          ? 'Grátis'
                          : `${formattedItemValue.value} ${formattedItemValue.label}`}
                      </span>
                      {isPaymentWithPointsAndCash && `+ ${currencyMask(totalCashValue)}`}
                    </VertTypography.Paragraph>
                  </Col>
                </Col>
              </Col>
              <Col span={24}>
                <Row>
                  {!hasFreeItem && (
                    <Col className={'padding-top-regular'} span={24}>
                      <VertButton
                        className='w-full'
                        type='highlight'
                        onClick={() => goToProductDetailsPage(item.productSkuId)}
                        style={{ display: supplierWithoutShipping ? 'block' : 'none' }}
                      >
                        Resgatar novamente
                      </VertButton>
                    </Col>
                  )}
                  <Col className={'padding-y-extra-small'} span={24}>
                    {!isLoading && isEnabled &&
                      checkIfOrderWas10DaysAgo() &&
                      ratingList &&
                      (!ratingList[item?.productSkuId] ||
                        ratingList[item?.productSkuId]?.status === 404) && (
                        <VertButton
                          className='w-full'
                          type='default'
                          onClick={() => {
                            handleChangeSkuTarget(item?.productSkuId);
                            handleChangeModal(true);
                          }}
                        >
                          Avalie seu pedido
                        </VertButton>
                      )}
                  </Col>
                </Row>
              </Col>
            </Col>
          );
        })}

        {isEnabled && checkIfOrderWas10DaysAgo() && (
          <RatingProducts
            items={(items || []).filter(({ productSku }) => skuTargetForRating === productSku)}
            open={ratingModalOpen}
            onClose={() => {
              handleChangeModal(false);
            }}
          />
        )}
      </Col>
    );
  });
};
